// frontend/src/pages/ResetPasswordPage.js
import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import  api  from '../services/api';

function ResetPasswordPage() {
    const { token } = useParams(); // Obtiene el :token de la URL
    const navigate = useNavigate();

    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');

        if (newPassword !== confirmPassword) {
            setError('Las contraseñas no coinciden.');
            return;
        }

        if (newPassword.length < 8) {
            setError('La contraseña debe tener al menos 8 caracteres.');
            return;
        }

        try {
            await api.post('/auth/reset-password', {
                token: token,
                new_password: newPassword
            });
            setMessage('¡Contraseña actualizada con éxito! Ya puedes iniciar sesión.');

            // Redirigir a login después de 3 segundos
            setTimeout(() => {
                navigate('/login');
            }, 3000);

        } catch (err) {
            setError(err.response?.data?.detail || 'El token es inválido o ha expirado.');
            console.error(err);
        }
    };

    return (
        <div className="container mt-5" style={{ maxWidth: '500px' }}>
            <div className="card shadow-sm">
                <div className="card-body p-4">
                    <h2 className="card-title text-center mb-4">Crear Nueva Contraseña</h2>

                    {message && <div className="alert alert-success">{message}</div>}
                    {error && <div className="alert alert-danger">{error}</div>}

                    {!message && (
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label htmlFor="newPassword" className="form-label">Nueva Contraseña</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="newPassword"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="confirmPassword" className="form-label">Confirmar Contraseña</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="confirmPassword"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                />
                            </div>
                            <button type="submit" className="btn btn-primary w-100">Restablecer Contraseña</button>
                        </form>
                    )}

                    {message && (
                        <div className="text-center mt-3">
                            <Link to="/login">Ir a Iniciar Sesión</Link>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ResetPasswordPage;